import IhmException from '@ch-types/CoralExceptionTypes/IhmException';

export default class ClientException extends IhmException {}
